import React, { useState } from "react";
import PropTypes from "prop-types";
import { Paper, Typography, Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { accountVerificationActions } from "../../store/actions/accountVerification/accountVerification";
import { compose } from "../../utils/compose";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Settings from "../../icons/Settings";
import Angel from "../../icons/Angel";
import Done from "../../icons/Done";
import Edit from "@material-ui/icons/Edit";
import { makeStyles } from "@material-ui/styles";
import useInterval from '../../utils/useInterval';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    textAlign: "center"
  },
  success: {
    color: "green"
  },
  button: {
    marginTop: theme.spacing(1)
  },
  counter: {
    textTransform: "lowercase",
    // marginLeft: theme.typography.button.fontSize
  }
}));

const EmailVerification = props => {
  const classes = useStyles();
  const {
    emailVerificationStatus,
    // verificationEmail,
    onSendVerificationEmail,
    // onClearVerificationEmailSent
  } = props;
  const { t } = useTranslation();
  const [delay, setDelay] = useState(null);
  const [count, setCount] = useState(0);

  useInterval(() => {
    if(count > 0) {
      setCount(prev => (prev-1));
    }
    if(count === 0) {
      setDelay(null);
    }
  }, delay)

  const startButtonTimer = () => {
    setCount(10);
    setDelay(1000);
  }

  const sendVerificationEmailHandler = ev => {
    if(count === 0) {
      onSendVerificationEmail(ev);

      startButtonTimer();
    }
  };

  return (
    <div className={classes.root}>
      {emailVerificationStatus.IsVerified ? (
        <>
          <Typography variant="body1" gutterBottom>
            {t('emailConfirmed')}
          </Typography>
          <Done className={classes.success} />
        </>
      ) : (
        <>
          <Typography variant="body1" gutterBottom>
            {t('shouldConfirmEmailWithAction')}
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            onClick={sendVerificationEmailHandler}
            className={classes.button}
            disabled={count !== 0}
          >
            {t('sendEmail')} {count !== 0 ? <span className={classes.counter}>&nbsp;{`(${count}s)`}</span> : null}
          </Button>
        </>
      )}
    </div>
  );
};

EmailVerification.propTypes = {
  emailVerificationStatus: PropTypes.object.isRequired,
  verificationEmail: PropTypes.object.isRequired,
  onSendVerificationEmail: PropTypes.func.isRequired,
  onClearVerificationEmailSent: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    emailVerificationStatus:
      state.accountVerification.verificationStatus.emailVerificationStatus,
    verificationEmail: state.accountVerification.verificationEmail
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSendVerificationEmail: () =>
      dispatch(accountVerificationActions.sendVerificationEmail()),
    onClearVerificationEmailSent: () =>
      dispatch(accountVerificationActions.clearVerificationEmailSent())
  };
};

const composed = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(EmailVerification);

export default composed;
